var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('List',{attrs:{"mare_id":_vm.horse.horse_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }